import { container } from 'src/StaticContainer';

export const log = container.get('Logger').getSubLogger({ name: 'admin:trading-hours' });
